import React from "react";
import Coursecard from "./Coursecard";
import { universities } from "./universities";

export default function Muj() {

  const courses = universities.find(
    (u) => u.university === "Manipal University Jaipur"
  ).courses;

  return (

    <>
      
      {/* ABOUT SECTION */}

      <section className="py-5" style={{ background: "#f8f9ff" }}>
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT */}
            <div className="col-lg-5">

              <span
                className="badge mb-3 px-3 py-2"
                style={{ background: "#6C63FF" }}
              >
                ABOUT MUJ
              </span>

              <h1 className="fw-bold mb-4">
                Manipal University
                <span style={{ color: "#6C63FF" }}> Jaipur</span>
              </h1>

              <p className="text-muted">
                Manipal University Jaipur is a leading private university
                offering world-class education, modern infrastructure,
                research opportunities, and excellent placement support.
              </p>

              <p className="text-muted">
                With a vibrant campus, experienced faculty, and
                industry-focused curriculum, MUJ empowers students
                to build successful careers.
              </p>

              <div className="row mt-4">

                <div className="col-6 mb-3">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-primary">25K+</h4>
                    <small>Students</small>
                  </div>
                </div>

                <div className="col-6 mb-3">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-danger">100+</h4>
                    <small>Programs</small>
                  </div>
                </div>

                <div className="col-6">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-success">300+</h4>
                    <small>Faculty</small>
                  </div>
                </div>

                <div className="col-6">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-warning">95%</h4>
                    <small>Placement</small>
                  </div>
                </div>

              </div>

            </div>


            {/* RIGHT */}
            <div className="col-lg-7">

              <div
                className="position-relative mx-auto"
                style={{
                  width: "500px",
                  height: "500px",
                  maxWidth: "100%"
                }}
              >

                {/* Orbit */}
                <div
                  style={{
                    width: "380px",
                    height: "380px",
                    border: "2px dashed #c9c7ff",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)"
                  }}
                />

                {/* Center Logo */}
                <div
                  className="bg-white shadow-lg rounded-circle d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "200px",
                    height: "200px",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)"
                  }}
                >
                  <img
                    src="/mujlogo.png"
                    alt="MUJ"
                    style={{ width: "120px" }}
                  />
                </div>


                {/* Top */}
                <div
                  className="bg-primary text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    top: "0",
                    left: "50%",
                    transform: "translateX(-50%)"
                  }}
                >
                  <i className="bi bi-building fs-1"></i>
                </div>


                {/* Left */}
                <div
                  className="bg-success text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    left: "0",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }}
                >
                  <i className="bi bi-book fs-1"></i>
                </div>


                {/* Right */}
                <div
                  className="bg-danger text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    right: "0",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }}
                >
                  <i className="bi bi-mortarboard fs-1"></i>
                </div>


                {/* Bottom Left */}
                <div
                  className="bg-warning rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    bottom: "20px",
                    left: "70px"
                  }}
                >
                  <i className="bi bi-laptop fs-1"></i>
                </div>


                {/* Bottom Right */}
                <div
                  className="bg-info text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    bottom: "20px",
                    right: "70px"
                  }}
                >
                  <i className="bi bi-trophy fs-1"></i>
                </div>

              </div>

            </div>

          </div>
        </div>
      </section>


      {/* COURSE CARDS */}

      <div
        className="container-fluid py-5"
        style={{ background: "#f5f5f5" }}
      >

        <div className="container">

          <div className="row g-4">

            {courses.map((course) => (

              <div
                className="col-lg-3 col-md-6"
                key={course.id}
              >

                <Coursecard
                  course={{
                    ...course,
                    universityName: "Manipal University Jaipur"
                  }}
                />

              </div>

            ))}

          </div>

        </div>

      </div>

    </>
  );
}